import {
  IdentityRepositories,
  IdentityRepositoryInterface,
} from "./identity-repositories";
import { IdentityStorageRepository } from "./IdentityStorageRepository";
import { LocalStorageRepository } from "./LocalStorageRepository";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import {
  DataWarehouseEventType,
  DataWarehouseService,
} from "../DataWarehouseService";
import { WindowRepository } from "../TrackingContext";
import { InstantConfigService } from "../InstantConfig";
import {
  Action,
  CommunicationService,
  eventsRepository,
} from "../CommunicationService";

@singleton()
export class PpidProvider {
  constructor(
    @inject(DataWarehouseService) private dataWarehouse: DataWarehouseService,
    @injectWithTransform(Logger, LoggerTransformer, "UserIdentity")
    private logger: Logger,
    @inject(WindowRepository) private windowContextRepository: WindowRepository,
    @inject(InstantConfigService)
    private instantConfigService: InstantConfigService,
    @inject(IdentityStorageRepository)
    private identityStorageRepository: IdentityStorageRepository,
    @inject(LocalStorageRepository)
    private localStorageRepository: LocalStorageRepository,
    @inject(CommunicationService)
    private communicationService: CommunicationService,
  ) {}

  private getPPID(strategy: IdentityRepositories): IdentityRepositoryInterface {
    this.logger.info("active strategy: ", strategy);
    switch (strategy) {
      case IdentityRepositories.IDENTITY_STORAGE:
        return this.identityStorageRepository;
      case IdentityRepositories.LOCAL:
      default:
        return this.localStorageRepository;
    }
  }

  private async generatePPID(): Promise<void> {
    try {
      const strategy = this.instantConfigService.get(
        "icPpidRepository",
        IdentityRepositories.LOCAL,
      );
      const ppid = await this.getPPID(strategy).get();
      this.dataWarehouse.track(DataWarehouseEventType.identity, {
        partner_name: "Google",
        partner_identity_id: ppid,
      });
      this.communicationService.emit(
        new Action(eventsRepository.IDENTITY_PARTNER_DATA_OBTAINED, {
          payload: {
            partnerName: "Google",
            partnerIdentityId: ppid,
          },
        }),
      );
      this.windowContextRepository.set("ppid", { value: ppid });
      this.logger.info("Passed PPID to page-level targeting");
    } catch (e) {
      this.logger.error("Setting up PPID has failed!", e);
    }
  }

  async setPpid(): Promise<void> {
    if (this.instantConfigService.get("icPpid", false)) {
      this.logger.info("enabled - awaiting setup");
      await this.generatePPID();
    } else {
      this.logger.info("disabled");
    }
  }
}
